import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Tooltip } from 'antd'
import TableLayout from '../../components/TableLayout'

const UsersListContainer = () => {
    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'full_name',
            filtered: true,
            sorter: true,
        },
        {
            title: 'Correo',
            dataIndex: 'email',
            filtered: true,
            sorter: true,
        },
        {
            title: 'Perfil',
            dataIndex: 'role.name',
            filtered: true,
            sorter: true,
        },
        {
            title: 'Creación',
            dataIndex: 'created_at',
            filtered: true,
            sorter: true,
        },
        {
            title: 'Actualizacíón',
            dataIndex: 'updated_at',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Acciones',
            dataIndex: 'actions',
        },
    ]

    return (
        <>
            <TableLayout
                title="Listado de usuarios"
                columns={columns}
                resource="users"
                actions={['excel', 'active', 'create', 'edit', 'show', 'pdf']}
                additionalAction={record => {
                    return (
                        <Tooltip title="Horario" placement="top">
                            <Link to={`/users/schedule/${record.id}/`} style={{ marginLeft: '5px' }}>
                                <Button type="primary" shape="circle" icon="calendar" />
                            </Link>
                        </Tooltip>
                    )
                }}
            />
        </>
    )
}

export default UsersListContainer
